<section class="contact-container">
  <div *ngIf="!submitted" class="inner">
    <header class="contact-us-v2-header-container">
      <svg
        width="61"
        height="61"
        viewBox="0 0 61 61"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="30.311" cy="30.5" r="30.311" fill="#00030A" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M33.4489 24.6946L39.2529 30.4999L33.4489 36.3052L32.5049 35.3612L36.7009 31.1666H21.6436V29.8332H36.7009L32.5049 25.6386L33.4489 24.6946Z"
          fill="#FAF2F2"
        />
      </svg>

      <h4>Tell us a bit. Wait for our call</h4>
    </header>
    <div [formGroup]="contactForm" class="form-container">
      <input
        type="text"
        placeholder="Full name"
        name="name"
        formControlName="name"
      />
      <input
        type="text"
        placeholder="Email"
        name="email"
        formControlName="email"
      />
      <ngx-intl-tel-input
        [cssClass]="'contact-v2-phone-input-inner'"
        class="contact-v2-phone-input"
        [preferredCountries]="preferredCountries"
        [enableAutoCountrySelect]="true"
        [enablePlaceholder]="true"
        [searchCountryFlag]="true"
        [searchCountryField]="[
          SearchCountryField.Iso2,
          SearchCountryField.Name
        ]"
        [selectFirstCountry]="false"
        [selectedCountryISO]="CountryISO.UnitedArabEmirates"
        [phoneValidation]="true"
        [separateDialCode]="separateDialCode"
        [numberFormat]="PhoneNumberFormat.International"
        name="phone"
        formControlName="phone"
      ></ngx-intl-tel-input>
    </div>
    <button
      class="nav-button nav-button--darkBtn"
      [disabled]="!contactForm.valid"
      (click)="onSubmit()"
    >
      Submit
    </button>
  </div>
  <div *ngIf="submitted" class="submitted-container">
    <h1 data-aos="fade-in" data-aos-delay="400">
      Thank you for reaching us, We will contact you as soon as possible
    </h1>
    <a
      data-aos="fade-in"
      data-aos-delay="700"
      class="landing-v2-button landing-v2-button--darkBtn"
      href="/"
    >
      <span class="icon">
        <svg
          width="26"
          height="27"
          viewBox="0 0 26 27"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <line
            x1="0.927659"
            y1="25.8056"
            x2="25.0061"
            y2="1.72716"
            stroke="currentColor"
            stroke-width="2"
          />
          <line
            x1="6.25293"
            y1="1.43408"
            x2="25.7132"
            y2="1.43408"
            stroke="currentColor"
            stroke-width="2"
          />
          <line
            x1="24.7129"
            y1="22.0596"
            x2="24.7129"
            y2="2.43399"
            stroke="currentColor"
            stroke-width="2"
          />
        </svg>
      </span>
      <span> Homepage </span>
    </a>
  </div>
</section>
